import { Observable } from 'rxjs';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-payment-option-list-item',
  templateUrl: './payment-option-list-item.component.html',
  styleUrls: ['./payment-option-list-item.component.css']
})
export class PaymentOptionListItemComponent implements OnInit {

  @Input() card;
  @Input() hideRemove = false;
  @Output() clickedDeleteCard: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  deleteCard(id: string, fingerprint: string) {
    this.clickedDeleteCard.emit({
      id,
      fingerprint
    });
  }

}
